import './OkModalOnboarding.scss';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from 'react-modal';

class OkModalOnboarding extends Component {
    constructor(props) {
        super(props);
        this.container = React.createRef();
    }

    renderContent = () => {
        const { children, header, body, footer } = this.props;
        if (children) {
            return children;
        }

        return (
            <Fragment>
                <div className="ok-modal-onboarding__header">{header}</div>
                <div className="ok-modal-onboarding__body">{body}</div>
                <div className="ok-modal-onboarding__footer">{footer}</div>
            </Fragment>
        );
    };

    render() {
        const { className, overlayClassName, modalIsOpen, onClose, headerCloseIcon } = this.props;

        const classNameOverlay = classNames(overlayClassName, 'ok-modal-onboarding__overlay');
        const classNameContent = classNames(className, 'ok-modal-onboarding__content');

        return (
            <Modal
                onAfterOpen={this.handleAfterOpen}
                overlayClassName={classNameOverlay}
                className={classNameContent}
                isOpen={modalIsOpen}
                ariaHideApp={false}
            >
                <div className="ok-modal-onboarding__full-size" ref={this.container}>
                    {headerCloseIcon && <i onClick={onClose} className="icons icons--icon-close" />}
                    {this.renderContent()}
                </div>
            </Modal>
        );
    }
}

OkModalOnboarding.propTypes = {
    headerCloseIcon: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    overlayClassName: PropTypes.string,
    onClose: PropTypes.func,
    closeModal: PropTypes.func,
    header: PropTypes.object,
    body: PropTypes.object,
    modalIsOpen: PropTypes.bool,
    footer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

OkModalOnboarding.defaultProps = {
    className: '',
    overlayClassName: '',
    headerCloseIcon: true,
};

export default OkModalOnboarding;
